export default "__VITE_ASSET__eGYv8DA6__"